<script lang="ts">
	import type { IArticle } from 'customTypes/news';
	import UpdateNews from 'assets/svg/updateNews.svg?component';
	import NewsList from './NewsList/NewsList.svelte';
	import { timeSince } from 'utils/SocialNetworksUtils/DateTools/DateTools';
	import { onMount } from 'svelte';
	import isInViewport from 'utils/isInViewport';
	import { throttle } from 'utils/decorators';
	import { _ } from 'utils/i18/i18n';
	import { htmlRegex } from 'utils/regex/html.js';
	import { getCoinNews } from 'services/news/coin-news';
	import { browser } from '$app/environment';

	export let dark = false;
	export let name: string;
	export let abbr: string;
	export let logo: string;
	export let withTitle = true;
	export let withUpdateOption = true;

	let allNews: IArticle[];
	let restNews: IArticle[];
	let headNews: IArticle;
	let shortText: string;
	let newsAge: string;
	let isInUserViewport = false;
	let isLoaded = false;
	let newsBlockRef;

	async function onUpdate() {
		if (!browser) return;
		if (withUpdateOption) {
			try {
				const {
					list,
					headNews: head,
					restNews: restList,
				}: { list: IArticle[]; headNews: IArticle; restNews: IArticle[] } = await getCoinNews(abbr, name);
				allNews = list;
				restNews = restList;
				headNews = head;
			} catch (error) {
				console.error(error);
			}
		}
	}

	onMount(() => {
		isInUserViewport = isInViewport(newsBlockRef);
		if (isInUserViewport) {
			isLoaded = true;
			onUpdate();
		} else {
			isLoaded = false;
			document.addEventListener('scroll', handleScroll);
		}

		return () => {
			document.removeEventListener('scroll', handleScroll);
		};
	});

	const handleScroll = throttle(() => {
		isInUserViewport = isInViewport(newsBlockRef, 700);
	}, 200);

	$: if (isInUserViewport && !isLoaded) {
		isLoaded = true;
		onUpdate();
		document.removeEventListener('scroll', handleScroll);
	}

	$: {
		if (headNews) {
			shortText = getShortText(headNews?.description);
			newsAge = timeSince(new Date(headNews.published_at));
		}
	}
	function getShortText(text: string) {
		return text ? text?.replace(htmlRegex, '')?.substring(0, 180) + '...' : '';
	}

	const onErrorCoinLogo = (event: Event) => {
		(event.target as HTMLImageElement).style.opacity = '0.5';
		return ((event.target as HTMLImageElement).src = logo);
	};
</script>

<section class="news" class:dark bind:this={newsBlockRef}>
	{#if allNews && allNews?.length > 0}
		{#if withTitle}
			<h2 class="news-title">{name} {$_('coinDetailed.news')}</h2>
		{/if}
		<div class="news-wrapper" class:no-update={!withUpdateOption}>
			{#if withUpdateOption}
				<!-- TODO -->
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<!-- svelte-ignore a11y-no-static-element-interactions -->
				<div class="update-news" on:click={onUpdate}>
					<UpdateNews width={15} height={12} class="update-icon" />
					<h3 class="update-text">{$_('coinDetailed.news')}</h3>
				</div>
			{/if}
			<div class="head">
				{#if headNews?.image}
					<img src={headNews.image} on:error={onErrorCoinLogo} alt="news" class="news-logo" />
				{:else}
					<img src={logo} alt="news" class="news-logo news-opacity" />
				{/if}

				<div>
					<h3 class="title">{headNews.title}</h3>
					<p class="text">{shortText}</p>
					<div class="info">
						<a href={headNews.url} target="#" class="link">{$_('coinDetailed.readMore')}</a>
						<p class="source">
							{headNews.source} <span class="time"> &middot {newsAge}</span>
						</p>
					</div>
				</div>
			</div>
			<NewsList {dark} list={restNews} {onUpdate} {withUpdateOption} />
		</div>
	{/if}
</section>

<style lang="scss">
	@import 'newsBlock';
</style>
